import { defineMessages } from '@jutro/locale';

export default defineMessages({
    versionDiffTitle: {
        id: 'gateway.version.diff.title',
        defaultMessage: 'Select Quote Versions To Compare'
    },
    Compare: {
        id: 'ml-gateway.views.policy-summary.Compare',
        defaultMessage: 'Compare'
    },
    Cancel: {
        id: 'ml-gateway.views.policy-summary.Cancel',
        defaultMessage: 'Cancel'
    },
    Close: {
        id: 'ml-gateway.views.policy-summary.Close',
        defaultMessage: 'Close'
    },
    VersionDiffListPopupTitle: {
        id: 'gateway.version.diff.list.popup.title',
        defaultMessage: 'Your Comparison'
    }
})